/** @type {import('next-sitemap').IConfig} */
const siteUrl = 'https://fagmobler.no';

const serverSitemaps = [
  '/sitemaps/inspirasjon.xml',
  '/sitemaps/products.xml',
  '/sitemaps/articles.xml',
  '/sitemaps/productCategories.xml',
  '/sitemaps/serie.xml',
];

module.exports = {
  siteUrl,
  generateRobotsTxt: true,
  generateIndexSitemap: false,
  exclude: [...serverSitemaps],
  robotsTxtOptions: {
    additionalSitemaps: serverSitemaps.map((siteMap) => {
      return `${siteUrl}${siteMap}`;
    }),
  },
};
